import React, {useEffect, useState, useRef} from 'react'
import {useCustomQuery} from '@salesforce/commerce-sdk-react'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useUsid} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const useDeliveryOptions = ({accessToken = null, cache = false}) => {
    const [isLoading, setIsLoading] = useState(true)
    const [deliveryOptionResponse, setDeliveryOptionResponse] = useState(null)
    const {usid} = useUsid()
    const {site} = useMultiSite()
    const cacheKey = `deliveryOptions_${site.id}`
    const hasFetched = useRef(false);

    const {refetch} = useCustomQuery(
        {
            options: {
                method: 'POST',
                parameters: {
                    siteId: site.id,
                    c_usid: usid
                },
                customApiPathParameters: {
                    apiVersion: 'v1',
                    endpointPath: '/delivery-options',
                    apiName: 'pdp'
                },
                body: JSON.stringify({
                    accessToken: accessToken
                })
            },
            rawResponse: false
        },
        {
            enabled: false,
            onSuccess: (response) => {
                setIsLoading(false)
                setDeliveryOptionResponse(response)

                const { geolocation, ...deliveryOptions } = response

                if (cache) {
                    sessionStorage.setItem(cacheKey, JSON.stringify(deliveryOptions))
                } else {
                    sessionStorage.removeItem(cacheKey)
                }
            },
            onError: (error) => {
                setIsLoading(false)
                logger.error('Error getting delivery options:', {
                    namespace: 'Delivery options',
                    additionalProperties: {error: error.message, stack: error.stack}
                })
            }
        }
    )

    useEffect(() => {
        if(accessToken !== null && !hasFetched.current) {
            const cachedData = sessionStorage.getItem(cacheKey)

            if (cachedData) {
                try {
                    setDeliveryOptionResponse(JSON.parse(cachedData))
                } catch (error) {
                    logger.error('Error parsing delivery options:', {
                        namespace: 'Delivery options',
                        additionalProperties: {error: error.message, stack: error.stack}
                    })
                }

                setIsLoading(false)
            } else {
                refetch()
            }

            hasFetched.current = true;
        }
    }, [accessToken])


    return {
        isLoading,
        deliveryOptionResponse
    }
}

export {useDeliveryOptions}
